import { useState } from "react";
import format from "date-fns/format";
import { Calendar } from "react-date-range";
import Input from "../Input";

export default function DatePicker({ label, date, setDate, ...rest }) {
  const [isOpen, setIsOpen] = useState(false);
  return (
    <div {...rest} style={{ position: "relative" }}>
      <Input
        value={format(date, "dd/MM/yyyy")}
        readOnly
        label={label}
        required
        onClick={() => setIsOpen((prev) => !prev)}
        placeholder="22/01/2023"
      />
      {isOpen && (
        <div
          onMouseEnter={() => setIsOpen(true)}
          onMouseLeave={() => setIsOpen(false)}
          className=""
        >
          <Calendar
            date={date}
            onChange={(d) => {
              setDate(d);
              setIsOpen(false);
            }}
            color="#1D523B"
            className="absolute z-10 mt-[10px] left-[10px] border-2 border-gray-200"
          />
        </div>
      )}
    </div>
  );
}
